import { render, staticRenderFns } from "./InlineTechpack.vue?vue&type=template&id=489a2e09&scoped=true"
import script from "./InlineTechpack.vue?vue&type=script&lang=ts"
export * from "./InlineTechpack.vue?vue&type=script&lang=ts"
import style0 from "./InlineTechpack.vue?vue&type=style&index=0&id=489a2e09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a2e09",
  null
  
)

export default component.exports